import { render, staticRenderFns } from "./CategoryManagement.vue?vue&type=template&id=51a0c7ef"
import script from "./CategoryManagement.vue?vue&type=script&lang=ts"
export * from "./CategoryManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports